import { render, staticRenderFns } from "./DatiCertificazioni.vue?vue&type=template&id=9f219b84"
import script from "./DatiCertificazioni.vue?vue&type=script&lang=js"
export * from "./DatiCertificazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports